export default __webpack_public_path__ + "static/media/Urban Armour Gear.9deeb621.svg";